import * as React from 'react'

import { Box, Radio } from '@factorialco/deprecated-design-system'
import { AtsJobPostingStatusesEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onChange: (status: AtsJobPostingStatusesEnum) => void
  currentStatus: AtsJobPostingStatusesEnum
}

export const PublishModalOptions = ({ currentStatus, onChange }: Props) => {
  return (
    <Box>
      <Radio.Wrap>
        <Radio
          name="jobs_section_type"
          option={{
            label: i18n.t('ats.job_details.publish_confirmation.publish.label'),
            value: 'published',
          }}
          description={i18n.t('ats.job_details.publish_confirmation.description')}
          value={currentStatus}
          onChange={() => onChange('published')}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name="jobs_section_type"
          option={{
            label: i18n.t('ats.job_details.publish_confirmation.publish_unlisted.label'),
            value: 'unlisted',
          }}
          value={currentStatus}
          description={i18n.t('ats.job_details.publish_confirmation.publish_unlisted.description')}
          onChange={() => onChange('unlisted')}
        />
      </Radio.Wrap>
    </Box>
  )
}
